// 中文
export default {
    public: {
        call :'您好！',
        logout: '退出登录',
        delSuccess:'删除成功',
        switching:'切换多语言成功',
        login: '登录/注册',
    },
    ykpHeader: {
        product: '产品',
        productList: '产品列表',
        // 左侧产品相关
        allProducts: '全部产品',
        searchLiterature: '搜文献',
        readLiterature: '读文献',
        writeLiterature: '写文献',
        translateLiterature: '翻译文献',
        
        // 用户相关
        userProduct: '用户产品',
        personalCenter: '个人中心',
        problemFeedback: '问题反馈',
        logout: '退出登录',
        
        // 问题反馈弹窗
        functionModule: '功能模块：',
        selectModule: '请选择存在问题的功能模块',
        problemDescription: '问题描述：',
        enterDescription: '请输入问题描述',
        problemScreenshot: '问题截图：',
        email: '邮箱：',
        enterEmail: '请输入邮箱',
        cancel: '取 消',
        submit: '提 交',
        feedbackSuccess: '问题反馈成功！',
        
        // 登录相关
        loginType: '登录类型',
        confirm: '确定',
        pleaseLogin: '请先登录',
        loginExpired: '登录已失效',
        pleaseUsePersonalAccount: '请使用个人账号登录',
        
        // 表单验证
        pleaseSelectModule: '请选择功能模块',
        pleaseEnterDescription: '请输入问题描述',
        pleaseEnterEmail: '请输入邮箱'
    },
}
